// extracted by mini-css-extract-plugin
module.exports = {"services":"services-module--services--11Wim","service":"services-module--service--Gw0Kz","more":"services-module--more--3TC1M","container":"services-module--container--2v0zL"};